System.register(["./dyn-index.js", "./dyn-index3.js", "./dyn-goober.modern.js", "./dyn-feature-products.js"], function(exports, module) {
  "use strict";
  var reactExports, requireReactDom, reactDomExports, m, sall;
  return {
    setters: [(module2) => {
      reactExports = module2.r;
    }, (module2) => {
      requireReactDom = module2.r;
      reactDomExports = module2.a;
    }, (module2) => {
      m = module2.m;
    }, (module2) => {
      sall = module2.s;
    }],
    execute: function() {
      exports({
        createPortalComponent,
        withOnMount
      });
      var client = {};
      var hasRequiredClient;
      function requireClient() {
        if (hasRequiredClient) return client;
        hasRequiredClient = 1;
        var m2 = requireReactDom();
        {
          client.createRoot = m2.createRoot;
          client.hydrateRoot = m2.hydrateRoot;
        }
        return client;
      }
      var clientExports = requireClient();
      var i = /* @__PURE__ */ new Map([["align-self", "-ms-grid-row-align"], ["color-adjust", "-webkit-print-color-adjust"], ["column-gap", "grid-column-gap"], ["gap", "grid-gap"], ["grid-template-columns", "-ms-grid-columns"], ["grid-template-rows", "-ms-grid-rows"], ["justify-self", "-ms-grid-column-align"], ["margin-inline-end", "-webkit-margin-end"], ["margin-inline-start", "-webkit-margin-start"], ["overflow-wrap", "word-wrap"], ["padding-inline-end", "-webkit-padding-end"], ["padding-inline-start", "-webkit-padding-start"], ["row-gap", "grid-row-gap"], ["scroll-margin-bottom", "scroll-snap-margin-bottom"], ["scroll-margin-left", "scroll-snap-margin-left"], ["scroll-margin-right", "scroll-snap-margin-right"], ["scroll-margin-top", "scroll-snap-margin-top"], ["scroll-margin", "scroll-snap-margin"], ["text-combine-upright", "-ms-text-combine-horizontal"]]);
      function n(n2, r) {
        let t = "";
        const a = i.get(n2);
        a && (t += `${a}:${r};`);
        const o = function(i2) {
          var n3 = /^(?:(text-(?:decoration$|e|or|si)|back(?:ground-cl|d|f)|box-d|(?:mask(?:$|-[ispro]|-cl)))|(tab-|column(?!-s)|text-align-l)|(ap)|(u|hy))/i.exec(i2);
          return n3 ? n3[1] ? 1 : n3[2] ? 2 : n3[3] ? 3 : 5 : 0;
        }(n2);
        1 & o && (t += `-webkit-${n2}:${r};`), 2 & o && (t += `-moz-${n2}:${r};`), 4 & o && (t += `-ms-${n2}:${r};`);
        const l = function(i2, n3) {
          var r2 = /^(?:(pos)|(background-i)|((?:max-|min-)?(?:block-s|inl|he|widt))|(dis))/i.exec(i2);
          return r2 ? r2[1] ? /^sti/i.test(n3) ? 1 : 0 : r2[2] ? /^image-/i.test(n3) ? 1 : 0 : r2[3] ? "-" === n3[3] ? 2 : 0 : /^(inline-)?grid$/i.test(n3) ? 4 : 0 : 0;
        }(n2, r);
        return 1 & l ? t += `${n2}:-webkit-${r};` : 2 & l ? t += `${n2}:-moz-${r};` : 4 & l && (t += `${n2}:-ms-${r};`), t += `${n2}:${r};`, t;
      }
      m(reactExports.createElement, n);
      function createPortalComponent(fc, payload, container, cb) {
        return reactDomExports.createPortal(reactExports.createElement(withOnMount(fc, cb), payload), container);
      }
      function withOnMount(comp, cb) {
        return (props) => {
          reactExports.useEffect(() => {
            cb == null ? void 0 : cb();
          }, []);
          return reactExports.createElement(comp, props);
        };
      }
      const getReactMountNode = exports("getReactMountNode", sall(() => {
        let root = null;
        function reducer(state, action) {
          switch (action.type) {
            case "push":
              return [...state, action.payload];
            case "remove":
              return state.filter((n2) => n2 !== action.payload);
            default:
              return state;
          }
        }
        const Container = reactExports.forwardRef(function Container2(_props, ref) {
          const [nodes, dispatch] = reactExports.useReducer(reducer, []);
          reactExports.useImperativeHandle(ref, () => ({
            dispatch
          }));
          return reactExports.createElement("div", {}, nodes);
        });
        let resolve = (_ref) => {
        };
        const p = new Promise((r) => resolve = r);
        return async () => {
          if (!root) {
            root = document.createElement("div");
            root.id = "elegoo-theme-root";
            document.body.appendChild(root);
            const app = clientExports.createRoot(root);
            app.render(reactExports.createElement(Container, {
              ref: (ref2) => {
                resolve(ref2);
              }
            }));
          }
          const ref = await p;
          return {
            async push(node) {
              ref.dispatch({
                type: "push",
                payload: node
              });
            },
            remove(node) {
              ref.dispatch({
                type: "remove",
                payload: node
              });
            }
          };
        };
      }));
      exports("createPortal", reactDomExports.createPortal);
    }
  };
});
